import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.19 8.42C6.77062 8.2233 6.31322 8.1209 5.85 8.12C4.09 8.12 2.66 9.55 2.66 11.31C2.66 13.07 4.09 14.5 5.85 14.5C6.4 14.5 6.91 14.35 7.36 14.11C6.84 13.23 6.53 12.22 6.53 11.12C6.53 10.15 6.77 9.23 7.19 8.42ZM9.2 16.65C8.34 15.78 7.16 15.23 5.85 15.23C3.37 15.23 1.33 17.15 1.15 19.59H5.65C6.52 18.3 7.76 17.28 9.2 16.65Z"
        fill="#5586D4"
      />
      <path
        d="M21.26 17.32C24.8554 17.32 27.77 14.4054 27.77 10.81C27.77 7.21463 24.8554 4.3 21.26 4.3C17.6646 4.3 14.75 7.21463 14.75 10.81C14.75 14.4054 17.6646 17.32 21.26 17.32Z"
        fill="#1F3E74"
      />
      <path
        d="M14.42 6.76C13.81 6.48 13.13 6.31 12.42 6.31C9.76 6.31 7.61 8.46 7.61 11.12C7.61 13.78 9.77 15.93 12.42 15.93C13.26 15.93 14.03 15.7 14.71 15.32C13.82 14.04 13.3 12.48 13.3 10.8C13.3 9.32 13.71 7.93 14.42 6.75V6.76Z"
        fill="#5586D4"
      />
      <path d="M21.26 18.81C16.2 18.81 12.05 22.73 11.67 27.7H30.84C30.6539 25.2849 29.5645 23.0287 27.789 21.3811C26.0134 19.7334 23.6822 18.8154 21.26 18.81Z" fill="#1F3E74" />
      <path d="M16.6 18.41C15.43 17.55 13.98 17.04 12.42 17.04C8.68 17.04 5.61 19.94 5.34 23.61H11.33C12.4457 21.3254 14.3086 19.4907 16.61 18.41H16.6Z" fill="#5586D4" />
    </svg>
  );
};

export default Icon;
